/* Subscription box tracker — live countdown.
   Re-derives the "N days" numerals from the absolute deadline/ship timestamps
   (data-deadline-ts / data-ship-ts) on each tick, so cached HTML self-corrects
   across day boundaries while the page is open.

   A single shared interval re-queries the DOM on every tick, so trackers added
   or removed dynamically (e.g. Shopify theme-editor section reloads) are picked
   up / dropped without leaking per-element intervals. The init guard keeps a
   second copy of this script (or a re-injected section) from spawning a
   duplicate interval. */
(function () {
  if (window.__ncbTrackerInit) return;
  window.__ncbTrackerInit = true;

  function tick(el) {
    var deadlineTs = parseInt(el.getAttribute('data-deadline-ts'), 10);
    var shipTs = parseInt(el.getAttribute('data-ship-ts'), 10);
    if (!Number.isFinite(deadlineTs) || !Number.isFinite(shipTs)) return;

    var now = Date.now() / 1000;
    var deadlineDays = Math.max(0, Math.floor((deadlineTs - now) / 86400));
    var shipDays = Math.max(0, Math.ceil((shipTs - now) / 86400));

    var dEl = el.querySelector('[data-tracker-deadline-days]');
    var sEl = el.querySelector('[data-tracker-ship-days]');
    var dpEl = el.querySelector('[data-tracker-deadline-plural]');
    var spEl = el.querySelector('[data-tracker-ship-plural]');
    if (dEl) dEl.textContent = String(deadlineDays);
    if (sEl) sEl.textContent = String(shipDays);
    if (dpEl) dpEl.textContent = deadlineDays === 1 ? '' : 's';
    if (spEl) spEl.textContent = shipDays === 1 ? '' : 's';
  }

  function tickAll() {
    var trackers = document.querySelectorAll('[data-tracker]');
    for (var i = 0; i < trackers.length; i++) tick(trackers[i]);
  }

  function init() {
    tickAll();
    setInterval(tickAll, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
